import Icon from "./Icon";
import { facilities, siteDetails } from "../siteContent";

const Facilities = () => (
  <section className="section section--lavender" id="facilities">
    <div className="container facilities-layout">
      <div className="facilities-copy">
        <p className="eyebrow">The home</p>
        <h2>Comfortable spaces for everyday life</h2>
        <p className="lead-copy">
          Ascot Lodge is an adapted four-floor home with lift access throughout,
          shared living and dining spaces, and a private enclosed garden.
        </p>
        <p>
          Residents can personalise their rooms with familiar belongings and,
          by arrangement, their own furniture. The team can talk through any
          mobility, access or equipment needs before admission.
        </p>
        <a className="button button--secondary" href="#contact">
          Ask about the home
          <Icon name="arrow" size={20} />
        </a>
      </div>

      <div className="amenities-card">
        <p className="amenities-card__label">At Ascot Lodge</p>
        <ul className="amenities-grid">
          {facilities.map(({ icon, title }) => (
            <li key={title}>
              <span className="icon-tile icon-tile--small">
                <Icon name={icon} size={22} />
              </span>
              <span>{title}</span>
            </li>
          ))}
        </ul>
        <a
          className="address-link"
          href={siteDetails.mapsUrl}
          rel="noreferrer"
          target="_blank"
        >
          <Icon name="location" size={22} />
          <span>
            <strong>Find us in Southport</strong>
            {siteDetails.addressInline}
          </span>
          <Icon name="external" size={18} />
        </a>
      </div>
    </div>
  </section>
);

export default Facilities;
